export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6977.f932fc45.jpg";